import { sdkRequest } from '@eventbrite/http';

export const LOGIN_URL = '/api/v3/auth/login/';
export const LOGIN_WITH_TOKEN_URL = '/auth/provision_from_token/';
/**
 *API to Login User
 */
export const logInUser = ({ data }) => {
    const fetchOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },

        body: JSON.stringify(data),
    };
    return sdkRequest(LOGIN_URL, fetchOptions)
        .then((response) => response)
        .catch((error) => {
            throw error.parsedError;
        });
};
